<template>
  <div class="w-full mt-4 overflow-y-auto overflow-x-hidden" style="grid-area: table">
    <template v-if="paginatedPolicies.length > 0">
      <div
        class="hidden md:grid lg:grid-cols-12 md:grid-cols-8 gap-2 w-full items-center text-left py-2 border-b font-semibold text-gray-700 text-xs md:text-sm"
      >
        <div class="md:col-span-1">ID</div>
        <div class="md:col-span-3">Nome</div>
        <div class="md:col-span-2">Início</div>
        <div class="md:col-span-2">Final</div>
        <div class="md:col-span-2">Responsável</div>
        <div class="md:col-span-2">Data do vínculo</div>
      </div>

      <TableDomainDsPolicy v-for="policy in paginatedPolicies" :key="policy.id" :data="policy" />
    </template>

    <EmptyList v-else title="Nenhuma política encontrada" />
  </div>

  <v-pagination
    v-if="paginatedPolicies.length > 0"
    v-model="currentPage"
    :total-visible="5"
    :per-page="itemsPerPage"
    :length="pageCount"
    density="comfortable"
    color="primary"
    @update:model-value="changePage"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import TableDomainDsPolicy from '@/components/designSystem/Table/TableDomainDsPolicies.vue'
import EmptyList from '@/components/EmptyList.vue'
import { MappedDomainPolicy } from '@/types/domain'

const props = defineProps<{
  policies: MappedDomainPolicy[]
}>()

const currentPage = ref(1)
const itemsPerPage = ref(5)

const paginatedPolicies = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  return props.policies.slice(start, start + itemsPerPage.value)
})

const pageCount = computed(() => Math.ceil(props.policies.length / itemsPerPage.value))

const changePage = (page: number) => {
  currentPage.value = page
}
</script>
